/**
 * Session timeout configuration values. Adjust these constants when you
 * need to change inactivity behavior globally.
 */
export const SESSION_TIMEOUT_MINUTES = 30;
export const SESSION_TIMEOUT_WARNING_SECONDS = 60;
